import React from 'react';
import ReactDOM from 'react-dom';
import './HeaderCSS.css';
import {SearchComponent} from '../sitesearch/SearchComponent'
import {createElementFromHTML} from "../../helpers/helpers";

class HeaderComponent extends React.Component {

    constructor(props) {
        super(props);
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';
        const culture = isSpanish ? 'es' : 'en';
        const mobileMenu = document.querySelector('#mobile-menu');
        if (!(mobileMenu === undefined || mobileMenu === null)) mobileMenu.style.marginTop = '105px';
        //mobile-menu
        this.state = {
            isSpanish,
            isOpen: false,
            isBusiness: false,
            alertDismissed: false,
            alert: '&nbsp;',
            travelerItems: [],
            businessItems: [],
            menuVisible: {
                flightsAirlines: false,
                beforeTraveling: false,
                parkingTransportation: false,
                shopsFoodServices: false,
                mapsAndDirections: false,
                aboutContact: false
            }
        };

        fetch(`/api/default/listitems?$filter=ParentId%20eq%20e32bfea0-0c49-6a75-a385-ff1400f4265d&sf_culture=${culture}&$orderby=Ordinal`)
            .then((req) => req.json())
            .then(j => {
                return j.value.map(item => {
                    const tempElements = createElementFromHTML(item.Content);
                    let items = [];
                    let href = '';
                    tempElements.forEach(child => {
                        if (child.firstChild.text === item.Title) {
                            href = child.firstChild.href;
                            return
                        }
                        items.push({href: child.firstChild.href, text: child.firstChild.text})
                    });
                    return {
                        title: item.Title,
                        href,
                        items
                    }
                })
            }).then(travelerItems => {
            this.setState(Object.assign(this.state, {travelerItems}));

        });
        fetch(`/api/default/listitems?$filter=ParentId%20eq%202f30fea0-0c49-6a75-a385-ff1400f4265d&sf_culture=${culture}&$orderby=Ordinal`)
            .then((req) => req.json())
            .then(j => {
                return j.value.map(item => {
                    const tempElements = createElementFromHTML(item.Content);
                    let items = [];
                    let href = '';
                    tempElements.forEach(child => {
                        if (child.firstChild.text === item.Title) {
                            href = child.firstChild.href;
                            return
                        }
                        items.push({href: child.firstChild.href, text: child.firstChild.text})
                    });
                    return {
                        title: item.Title,
                        href,
                        items
                    }
                })
            }).then(businessItems => {
            this.setState(Object.assign(this.state, {businessItems}));
            if (window.location.pathname === '/') {
                fetch(`/api/default/contentitems?$filter=Id%20eq%20b11ff8a0-0c49-6a75-a385-ff0700f4265d&sf_culture=${culture}`)
                    .then(req => req.json())
                    .then(res => res.value[0].Content).then(r => {

                    return r;
                })
                    .then(content => this.setState(Object.assign(this.state, {alert: content})))
            }
        })
    }

    toggleOpen = () => {
        this.setState(Object.assign(this.state, {isOpen: !this.state.isOpen}), () => {
            if (this.state.isOpen) {
                document.getElementById('main-container').style.position = 'fixed'
            } else {
                document.getElementById('main-container').style.position = 'relative'
            }
        })
    };

    toggleBusiness = (isBusiness) => {
        this.setState(Object.assign(this.state, {isBusiness}))
    };

    onMenuHover = (idx) => {
        let styles = this.state.menuVisible;
        switch (idx) {
            case 0:
                styles.flightsAirlines = true;
                break;
            case 1:
                styles.beforeTraveling = true;
                break;
            case 2:
                styles.parkingTransportation = true;
                break;
            case 3:
                styles.shopsFoodServices = true;
                break;
            case 4:
                styles.mapsAndDirections = true;
                break;
            case 5:
                styles.aboutContact = true;
                break;
            default:
                break;
        }

        this.setState(Object.assign(this.state, {menuVisible: Object.assign(this.state.menuVisible, {menuStyle: styles})}))

    };

    onMenuBlur = (idx) => {
        let styles = this.state.menuVisible;
        switch (idx) {
            case 0:
                styles.flightsAirlines = false;
                break;
            case 1:
                styles.beforeTraveling = false;
                break;
            case 2:
                styles.parkingTransportation = false;
                break;
            case 3:
                styles.shopsFoodServices = false;
                break;
            case 4:
                styles.mapsAndDirections = false;
                break;
            case 5:
                styles.aboutContact = false;
                break;
            default:
                break;
        }

        this.setState(Object.assign(this.state, {menuVisible: Object.assign(this.state.menuVisible, {menuVisible: styles})}))
    };

    render() {
        return (
            <div style={{position: "fixed", top: "0", left: "0", right: "0", zIndex: "99"}}>
                <div className="row d-md-none main-blue">
                    <div className="d-md-none align-self-center my-2 col-4 text-left pl-5">
                        <div onClick={this.toggleOpen} style={this.state.isOpen ? {
                            color: 'white',
                            position: 'absolute',
                            left: '115px',
                            fontWeight: 'bold',
                            top: '0',
                            bottom: '0',
                            margin: 'auto',
                            fontSize: 'larger'

                        } : {display: 'none'}}>X
                        </div>
                        <img src="/images/default-source/siteimages/iconsmenusystem/hb.png"
                             alt={""}
                             style={{maxHeight: '30px'}} className="img-fluid" onClick={this.toggleOpen}/>

                    </div>
                    <div className=" d-md-none col-4  my-0 p-0 align-self-center text-center">
                        <a href={ this.state.isSpanish ? "/es"  : "/"}> <img id="phxLogoTop2"
                                         src="/images/default-source/siteimages/logos/phxhwhtlogoonly.png"
                                         className="img-fluid"
                                         alt=""/></a>
                    </div>
                    <div className="d-md-none col-3 pr-4 align-self-center text-center ">
                        <a href={this.state.isSpanish ? "/" : "/es"} className="btn btn-culture btn-culture-mobile p-0">
                            <img
                                src={this.state.isSpanish ? '/images/default-source/siteimages/component-images/culturebutton.png' : '/images/default-source/siteimages/component-images/culturebutton_es.png'}/>
                        </a>

                    </div>
                    <div className="d-md-none p-0 col">
                        <SearchComponent/>
                    </div>

                </div>


                <div className="mobile-hb-menu d-md-none" style={this.state.isOpen ?
                    {
                        maxHeight: '5000px',
                        overflow: 'hidden',
                        transition: 'max-height 0.25s ease-in-out',
                        position: 'fixed',
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                        height: 'calc(100% - 70px)'
                    } :
                    {
                        maxHeight: '0px',
                        overflowY: 'hidden',
                        overflowX: 'hidden',
                        transition: 'max-height 0.25s ease-in-out'
                    }}>
                    <div className="mobile-hb-navigation"
                         style={this.state.isOpen ? {position: 'fixed', left: '0', right: '0', zIndex: 99} : {}}>
                        <div className="col-12 align-self-center">
                            <div onClick={() => this.toggleBusiness(false)}
                                 style={this.state.isBusiness ? {} : {color: 'rgba(133, 183, 217, 1)'}}
                                 className="btn my-2 py-0 btn-header">Travelers
                            </div>
                            {this.state.isSpanish ? null :
                                <div onClick={() => this.toggleBusiness(true)}
                                     style={this.state.isBusiness ? {color: 'rgba(133, 183, 217, 1)'} : {}}
                                     className="btn py-0 btn-header">Business
                                </div>
                            }

                        </div>
                    </div>
                    <div style={this.state.isOpen ? {paddingTop: '70px', paddingBttom: '70px'} : {
                        paddingTop: '16px',
                        paddingBttom: '16px'
                    }}>
                        {(this.state.isBusiness ? this.state.businessItems : this.state.travelerItems).map((item, idx) => {
                            return <div key={idx} style={{paddingBottom: '1em'}}>
                                <div className="col-12">
                                    <a href={item.href}>
                                        <div className="row no-gutters mobile-hb-row-main">
                                            <div className="col-11 align-self-center" style={{color: 'white'}}>
                                                {item.title}
                                            </div>
                                            <div className="col-1 align-self-center text-right"
                                                 style={{color: 'white'}}>
                                                <img style={{maxHeight: '15px'}} alt={""}
                                                     src="/images/default-source/siteimages/iconsmenusystem/right-arrow.png"/>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                {item.items.map((i, idx) => {
                                    return <div key={idx} className="col-12">
                                        <a href={i.href}>
                                            <div className="row no-gutters mobile-hb-row-secondary">
                                                <div className="col-12 align-self-center" style={{color: 'white'}}>
                                                    {i.text}
                                                </div>

                                            </div>
                                        </a>
                                    </div>
                                })}

                            </div>
                        })}
                    </div>
                </div>

                <div className="row d-none d-md-flex main-blue">

                    <div className="d-none d-md-block col-md-4 align-self-center float-left my-2 my-md-0 pr-md-0">
                        <div className="col text-center text-md-left p-0 pl-4">
                            <a href={this.state.isSpanish ? "/es" : "/"}>
                                <img id="phxLogoTop" alt={""}
                                     src="/images/default-source/siteimages/logos/phxhwht-min.png"
                                     className="img-fluid"/></a>
                        </div>
                    </div>
                    <div className="d-none d-md-block align-self-center col-8 text-right">
                        <div className="row mt-2 align-self-center mb-1">
                            <div className="col-11 align-self-center">
                                <a href="/business"
                                   style={this.state.isSpanish ? {display: 'none'} : {}}
                                   className="btn btn-header py-0">Business</a>
                                {this.state.isSpanish ? null :
                                    <a href="https://deervalleyairport.com" className="btn btn-header py-0">DVT</a>}
                                {this.state.isSpanish ? null :
                                    <a href="https://goodyearairport.com" className="btn btn-header py-0">GYR</a>}
                                <a href={this.state.isSpanish ? "/" : "/es"} className="btn btn-culture p-0">
                                    <img
                                        src={this.state.isSpanish ? '/images/default-source/siteimages/component-images/culturebutton.png' : '/images/default-source/siteimages/component-images/culturebutton_es.png'}/>

                                </a>

                                <a href={this.state.isSpanish ? "/es/AntesDeViajar/NecesidadesEspeciales" : "/BeforeTraveling/SpecialNeeds"}>
                                    <img
                                        src="/images/default-source/siteimages/iconsmenusystem/specialneeds.png"
                                        className="" style={{maxHeight: "35px"}}
                                        alt=""/>
                                </a>
                            </div>
                            <div className="col text-center">
                                <SearchComponent/>
                            </div>
                        </div>
                    </div>


                </div>

                <div className="row d-none d-md-flex main-black-t text-center">

                    <div className="col-md-2 px-0 py-2 main-header-hover d-flex align-content-stretch"
                         onMouseEnter={() => this.onMenuHover(0)}
                         onMouseLeave={() => this.onMenuBlur(0)}
                         style={this.state.menuVisible.flightsAirlines ? {backgroundColor: 'rgba(133, 183, 217, 1)'} : {}}>
                        <a className="align-self-center"
                           href={this.state.travelerItems.length > 0 ? this.state.travelerItems[0].href : '/'}
                           style={{width: '100%'}}>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Vuelos y' : 'Flights &'}
                            </div>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Aerolíneas' : 'Airlines'}
                            </div>
                        </a>
                    </div>
                    <div className="col-md-2 px-0 py-2 main-header-hover d-flex align-content-stretch"
                         onMouseEnter={() => this.onMenuHover(1)}
                         onMouseLeave={() => this.onMenuBlur(1)}
                         style={this.state.menuVisible.beforeTraveling ? {backgroundColor: 'rgba(133, 183, 217, 1)'} : {}}>
                        <a className="align-self-center"
                           href={this.state.travelerItems.length > 0 ? this.state.travelerItems[1].href : '/'}
                           style={{width: '100%'}}>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Antes de' : 'Before'}
                            </div>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Viajar' : 'Traveling'}
                            </div>
                        </a>
                    </div>
                    <div className="col-md-2 px-0 py-2 main-header-hover d-flex align-content-stretch"
                         onMouseEnter={() => this.onMenuHover(2)}
                         onMouseLeave={() => this.onMenuBlur(2)}
                         style={this.state.menuVisible.parkingTransportation ? {backgroundColor: 'rgba(133, 183, 217, 1)'} : {}}>
                        <a className="align-self-center"
                           href={this.state.travelerItems.length > 0 ? this.state.travelerItems[2].href : '/'}
                           style={{width: '100%'}}>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Estacionamiento y' : 'Parking &'}
                            </div>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Transporte' : 'Transportation'}
                            </div>
                        </a>

                    </div>
                    <div className="col-md-2 px-0 py-2 main-header-hover d-flex align-content-stretch"
                         onMouseEnter={() => this.onMenuHover(3)}
                         onMouseLeave={() => this.onMenuBlur(3)}
                         style={this.state.menuVisible.shopsFoodServices ? {backgroundColor: 'rgba(133, 183, 217, 1)'} : {}}>
                        <a className="align-self-center"
                           href={this.state.travelerItems.length > 0 ? this.state.travelerItems[3].href : '/'}
                           style={{width: '100%'}}>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Tiendas, Restaurantes y' : 'Shops, Food &'}
                            </div>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Servicios' : 'Services'}
                            </div>
                        </a>

                    </div>
                    <div className="col-md-2 px-0 py-2 main-header-hover d-flex align-content-stretch"
                         onMouseEnter={() => this.onMenuHover(4)}
                         onMouseLeave={() => this.onMenuBlur(4)}
                         style={this.state.menuVisible.mapsAndDirections ? {backgroundColor: 'rgba(133, 183, 217, 1)'} : {}}>
                        <a className="align-self-center"
                           href={this.state.travelerItems.length > 0 ? this.state.travelerItems[4].href : '/'}
                           style={{width: '100%'}}>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Mapas y' : 'Maps &'}
                            </div>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Direcciones' : 'Directions'}
                            </div>
                        </a>
                    </div>
                    <div className="col-md-2 px-0 py-2 main-header-hover d-flex align-content-stretch"
                         onMouseEnter={() => this.onMenuHover(5)}
                         onMouseLeave={() => this.onMenuBlur(5)}
                         style={this.state.menuVisible.aboutContact ? {backgroundColor: 'rgba(133, 183, 217, 1)'} : {}}>
                        <a className="align-self-center"
                           href={this.state.travelerItems.length > 0 ? this.state.travelerItems[5].href : '/'}
                           style={{width: '100%'}}>
                            <div className="col-12  p-0">
                                {this.state.isSpanish ? 'Contáctenos' : 'About &'}
                            </div>
                            <div className="col-12 p-0">
                                {this.state.isSpanish ? '' : 'Contact'}
                            </div>
                        </a>
                    </div>
                </div>
                <div style={{position: "fixed", left: "0", right: "0", zIndex: 1}}>
                    <div className="row text-center">
                        <div className="col-2 p-0" style={this.state.menuVisible.flightsAirlines ?
                            {
                                background: "white",
                                visibility: "visible",
                                listStyle: "none",
                                opacity: 1,
                                maxHeight: "5000px",
                                transition: "max-height 0s, visibility 0s, opacity 0.25s ease-in-out"
                            }
                            :
                            {
                                visibility: "hidden",
                                opacity: 0,
                                maxHeight: "0px",
                                listStyle: "none",
                                transition: "visibility 0s, opacity 0.25s ease-in-out"
                            }}
                             onMouseEnter={() => this.onMenuHover(0)}
                             onMouseLeave={() => this.onMenuBlur(0)}>
                            <ul className="p-0 mb-0" style={{listStyle: "none"}}>
                                {this.state.travelerItems.map((item, idx, items) =>

                                    idx === 0 && this.state.menuVisible.flightsAirlines ? item.items.map((e, ii, iit) =>
                                        <li
                                            key={e.text} style={{
                                            background: "rgba(133, 183, 217, 1)",
                                            color: "white",
                                            fontWeight: "bold"
                                        }}

                                            className={ii === iit.length - 1 ? "p-3 hover-white" : "mb-1 p-3 hover-white"}>
                                            <a href={e.href}>  {e.text} </a></li>) : null)}

                            </ul>
                        </div>
                        <div className="col-2 p-0" style={this.state.menuVisible.beforeTraveling ?
                            {
                                background: "white",
                                visibility: "visible",
                                listStyle: "none",
                                opacity: 1,
                                maxHeight: "5000px",
                                transition: "max-height 0s, visibility 0s, opacity 0.25s ease-in-out"
                            }
                            :
                            {
                                visibility: "hidden",
                                opacity: 0,
                                maxHeight: "0px",
                                listStyle: "none",
                                transition: "visibility 0s, opacity 0.25s ease-in-out"
                            }}
                             onMouseEnter={() => this.onMenuHover(1)}
                             onMouseLeave={() => this.onMenuBlur(1)}>
                            <ul className="p-0 mb-0" style={{listStyle: "none"}}>
                                {this.state.travelerItems.map((item, idx) =>
                                    idx === 1 && this.state.menuVisible.beforeTraveling ? item.items.map((e, ii, iit) =>
                                        <li
                                            key={e.text} style={{
                                            background: "rgba(133, 183, 217, 1)",
                                            color: "white",
                                            fontWeight: "bold"
                                        }}
                                            className={ii === iit.length - 1 ? "p-3 hover-white" : "mb-1 p-3 hover-white"}>
                                            <a href={e.href}>  {e.text} </a></li>) : null)}

                            </ul>
                        </div>
                        <div className="col-2 p-0" style={this.state.menuVisible.parkingTransportation ?
                            {
                                background: "white",
                                visibility: "visible",
                                listStyle: "none",
                                opacity: 1,
                                maxHeight: "5000px",
                                transition: "max-height 0s, visibility 0s, opacity 0.25s ease-in-out"
                            }
                            :
                            {
                                visibility: "hidden",
                                opacity: 0,
                                maxHeight: "0px",
                                listStyle: "none",
                                transition: "visibility 0s, opacity 0.25s ease-in-out"
                            }}
                             onMouseEnter={() => this.onMenuHover(2)}
                             onMouseLeave={() => this.onMenuBlur(2)}>
                            <ul className="p-0 mb-0" style={{listStyle: "none"}}>
                                {this.state.travelerItems.map((item, idx) =>
                                    idx === 2 && this.state.menuVisible.parkingTransportation ? item.items.map((e, ii, iit) =>
                                        <li
                                            key={e.text} style={{
                                            background: "rgba(133, 183, 217, 1)",
                                            color: "white",
                                            fontWeight: "bold"
                                        }}
                                            className={ii === iit.length - 1 ? "p-3 hover-white" : "mb-1 p-3 hover-white"}>
                                            <a href={e.href}>  {e.text} </a></li>) : null)}
                            </ul>
                        </div>
                        <div className="col-2 p-0" style={this.state.menuVisible.shopsFoodServices ?
                            {
                                background: "white",
                                visibility: "visible",
                                listStyle: "none",
                                opacity: 1,
                                maxHeight: "5000px",
                                transition: "max-height 0s, visibility 0s, opacity 0.25s ease-in-out"
                            }
                            :
                            {
                                visibility: "hidden",
                                opacity: 0,
                                maxHeight: "0px",
                                listStyle: "none",
                                transition: "visibility 0s, opacity 0.25s ease-in-out"
                            }}
                             onMouseEnter={() => this.onMenuHover(3)}
                             onMouseLeave={() => this.onMenuBlur(3)}>
                            <ul className="p-0 mb-0" style={{listStyle: "none"}}>
                                {this.state.travelerItems.map((item, idx) =>
                                    idx === 3 && this.state.menuVisible.shopsFoodServices ? item.items.map((e, ii, iit) =>
                                        <li
                                            key={e.text} style={{
                                            background: "rgba(133, 183, 217, 1)",
                                            color: "white",
                                            fontWeight: "bold"
                                        }}
                                            className={ii === iit.length - 1 ? "p-3 hover-white" : "mb-1 p-3 hover-white"}>
                                            <a href={e.href}>  {e.text} </a></li>) : null)}
                            </ul>
                        </div>
                        <div className="col-2 p-0"

                             style={this.state.menuVisible.mapsAndDirections ?
                                 {
                                     background: "white",
                                     visibility: "visible",
                                     listStyle: "none",
                                     opacity: 1,
                                     maxHeight: "5000px",
                                     transition: "max-height 0s, visibility 0s, opacity 0.25s ease-in-out"
                                 }
                                 :
                                 {
                                     visibility: "hidden",
                                     opacity: 0,
                                     maxHeight: "0px",
                                     listStyle: "none",
                                     transition: "visibility 0s, opacity 0.25s ease-in-out"
                                 }}
                             onMouseEnter={() => this.onMenuHover(4)} onMouseLeave={() => this.onMenuBlur(4)}>
                            <ul className="p-0 mb-0" style={{listStyle: "none"}}>
                                {this.state.travelerItems.map((item, idx) =>
                                    idx === 4 ? item.items.map((e, ii, iit) => <li key={e.text} style={{
                                        background: "rgba(133, 183, 217, 1)",
                                        color: "white",
                                        fontWeight: "bold"
                                    }} className={ii === iit.length - 1 ? "p-3 hover-white" : "mb-1 p-3 hover-white"}><a
                                        href={e.href}>  {e.text} </a></li>) : null)}

                            </ul>
                        </div>
                        <div className="col-2 p-0"

                             style={this.state.menuVisible.aboutContact ?
                                 {
                                     background: "white",
                                     visibility: "visible",
                                     listStyle: "none",
                                     opacity: 1,
                                     maxHeight: "5000px",
                                     transition: "max-height 0s, visibility 0s, opacity 0.25s ease-in-out"
                                 }
                                 :
                                 {
                                     visibility: "hidden",
                                     opacity: 0,
                                     maxHeight: "0px",
                                     listStyle: "none",
                                     transition: "visibility 0s, opacity 0.25s ease-in-out"
                                 }}
                             onMouseEnter={() => this.onMenuHover(5)} onMouseLeave={() => this.onMenuBlur(5)}>
                            <ul className="p-0 mb-0" style={{listStyle: "none"}}>
                                {this.state.travelerItems.map((item, idx) =>
                                    idx === 5 ? item.items.map((e, ii, iit) => <li key={e.text} style={{
                                        background: "rgba(133, 183, 217, 1)",
                                        color: "white",
                                        fontWeight: "bold"
                                    }} className={ii === iit.length - 1 ? "p-3 hover-white" : "mb-1 p-3 hover-white"}><a
                                        href={e.href}>  {e.text} </a></li>) : null)}

                            </ul>
                        </div>

                    </div>

                </div>

                {(this.state.alert === '&nbsp;') || this.state.alertDismissed ? null :
                    <div className="row alert-row">
                        <div className="col-6 offset-3 text-center py-2 align-self-center" style={{fontWeight: "bold"}}>
                            {this.state.alert}
                            {/*ATTENTION: PHX Sky Train&reg; undergoing shutdowns on October Saturdays.*/}
                            <a className="btn" href onClick={() => {
                                this.setState(Object.assign(this.state, {alertDismissed: true}))
                            }} style={{
                                background: "transparent",
                                fontSize: "large",
                                fontWeight: "bold",
                                fontFamily: "sans-serif",
                            }}>X</a>

                        </div>
                        {/*<div className="col-1 offset-md-2 d-flex align-content-stretch text-center">*/}

                        {/*<a className="btn" href onClick={() => {*/}
                        {/*this.setState(Object.assign(this.state, {alertDismissed: true}))*/}
                        {/*}} style={{*/}
                        {/*background: "transparent",*/}
                        {/*fontSize: "x-large",*/}
                        {/*fontWeight: "bold",*/}
                        {/*fontFamily: "sans-serif",*/}
                        {/*}}>X</a>*/}

                        {/*</div>*/}
                    </div>}


            </div>
        )
    }
}

let domContainer = document.querySelector('#mobile-header');

if (!(domContainer === undefined || domContainer === null) === true) ReactDOM.render(<HeaderComponent/>, domContainer);
